import defaultLang from '../en.json';
import jsonBreedArrayEN from '../steps/customV2/breed/dogbreeds/en/dogbreeds.json';
import jsonBreedArrayDE from '../steps/customV2/breed/dogbreeds/de/dogbreeds.json';
import jsonBreedArrayES from '../steps/customV2/breed/dogbreeds/es/dogbreeds.json';
import jsonBreedArrayFR from '../steps/customV2/breed/dogbreeds/fr/dogbreeds.json';
import jsonBreedArrayPT from '../steps/customV2/breed/dogbreeds/pt/dogbreeds.json';
import jsonBreedArrayRU from '../steps/customV2/breed/dogbreeds/ru/dogbreeds.json';
import jsonBreedArrayIT from '../steps/customV2/breed/dogbreeds/it/dogbreeds.json';
import jsonBreedArrayJA from '../steps/customV2/breed/dogbreeds/ja/dogbreeds.json';
import jsonBreedArrayKO from '../steps/customV2/breed/dogbreeds/ko/dogbreeds.json';
import jsonBreedArrayPL from '../steps/customV2/breed/dogbreeds/pl/dogbreeds.json';
import jsonBreedArrayTR from '../steps/customV2/breed/dogbreeds/tr/dogbreeds.json';
import jsonBreedArrayUK from '../steps/customV2/breed/dogbreeds/uk/dogbreeds.json';

const localizedBreedArrays = {
  de: jsonBreedArrayDE,
  es: jsonBreedArrayES,
  fr: jsonBreedArrayFR,
  pt: jsonBreedArrayPT,
  ru: jsonBreedArrayRU,
  it: jsonBreedArrayIT,
  ja: jsonBreedArrayJA,
  ko: jsonBreedArrayKO,
  pl: jsonBreedArrayPL,
  tr: jsonBreedArrayTR,
  uk: jsonBreedArrayUK,
  en: jsonBreedArrayEN,
};

const ageValueToTranslationKey = {
  '0-6 months': 'customV2_age_v1',
  '7-12 months': 'customV2_age_v2',
  '1-2 years': 'customV2_age_v3',
  '2-7 years': 'customV2_age_v4',
  'More than 7 years': 'customV2_age_v5',
  '1-5 years': 'start_page_age_v3',
  '5+ years': 'start_page_age_v4',
};

const issuesValueToTranslationKey = {
  'Difficulties with crate training': 'customV2_plan_text17',
  Biting: 'customV2_plan_text18',
  Barking: 'customV2_plan_text19',
  'Chewing or damaging furniture': 'customV2_plan_text20',
  'Very anxious and sad when left alone': 'customV2_plan_text21',
  'Eating trash outdoors': 'customV2_plan_text23',
  'Leash pulling': 'customV2_plan_text22',
  'Anxiety when left alone': 'customV2_plan_text21',
  'Difficulties with create training': 'customV2_plan_text17',
};

const walkingIssuesValueToTranslationKey = {
  'Pulling on the leash': 'customV2_plan_text22',
  'Eating trash from the streets': 'customV2_plan_text23',
  'Barking at other dogs': 'customV2_plan_text19',
  'Barking at people': 'customV2_plan_text19',
};

const ownerConcernValueToTranslationKey = {
  'Training and obedience issues': 'customV2_plan_text26',
  'Potty training challenges': 'customV2_plan_text25',
  'My puppy’s health or behavior': 'customV2_plan_text26',
  'Balancing puppy care with my personal responsibilities': 'customV2_plan_text26',
  'Feeling unsure about my decision to get a dog': 'customV2_plan_text26',
};

function getLocalizedBreedArray(lang) {
  return localizedBreedArrays[lang] || jsonBreedArrayEN;
}

function getBreedId(breed) {
  const breedData = jsonBreedArrayEN.find((item) => item.breed === breed);
  return breedData ? breedData.id : null;
}

function getLocalizedBreedName(breed, lang) {
  if (!breed) {
    return '';
  }

  const breedId = getBreedId(breed);
  const localizedArray = getLocalizedBreedArray(lang);
  const breedData = localizedArray.find((item) => item.id === breedId);

  return breedData ? breedData.breed : '';
}

function getFirstAnswerKey(answerObject) {
  if (!answerObject || Object.keys(answerObject).length === 0) {
    return '';
  }

  return Object.keys(answerObject)[0];
}

function getTranslate(translate) {
  if (typeof translate === 'function') {
    return translate;
  }

  const locales = typeof window !== 'undefined' && window.locales ? window.locales : null;
  const fallbackLocales = typeof window !== 'undefined' && window.defaultLocales ? window.defaultLocales : defaultLang;

  return (key) => locales?.[key] || fallbackLocales?.[key] || defaultLang[key] || key;
}

function mapIssues(answerObject, translationMap, translate, resultArray) {
  Object.keys(answerObject || {}).forEach((key) => {
    const value = answerObject[key];
    const translationKey = translationMap[value?.value];

    if (translationKey) {
      resultArray.push(translate(translationKey));
    }
  });
}

export function getDogProfileDisplayInfo({
  config,
  breedAnswers,
  ageAnswers,
  nameAnswers,
  issuesObj1,
  issuesObj2,
  issuesObj3,
  issuesObj4,
  ownerConcernsAnswer,
  translate,
  lang = 'en',
}) {
  const t = getTranslate(translate);
  const dogName = getFirstAnswerKey(nameAnswers);
  const breedNameValue = getFirstAnswerKey(breedAnswers);
  const rawPuppyValue = getFirstAnswerKey(ageAnswers);
  const puppyTranslationKey = ageValueToTranslationKey[rawPuppyValue];

  let puppyValue = '';
  if (rawPuppyValue) {
    puppyValue = puppyTranslationKey ? t(puppyTranslationKey) : t('customV2_age_v5');
  }

  const resultArray = [];
  if (issuesObj1) {
    Object.keys(issuesObj1).forEach((key) => {
      const value = issuesObj1[key];
      if (value?.value && value.value !== 'My dog is potty trained!' && value.value !== 'All good, no issues!') {
        resultArray.push(t('customV2_plan_text16'));
      }
    });
  }

  mapIssues(issuesObj2, issuesValueToTranslationKey, t, resultArray);
  mapIssues(issuesObj3, walkingIssuesValueToTranslationKey, t, resultArray);
  mapIssues(issuesObj4, issuesValueToTranslationKey, t, resultArray);

  const issues = [...new Set(resultArray)].join(', ');

  const customV21ResultArray = [];
  if (ownerConcernsAnswer && Object.keys(ownerConcernsAnswer).length > 0) {
    mapIssues(ownerConcernsAnswer, ownerConcernValueToTranslationKey, t, customV21ResultArray);
  } else {
    customV21ResultArray.push(t('customV2_plan_text26'));
  }

  const customV21Issues = [...new Set(customV21ResultArray)].join(', ');
  const issuesDisplay = config === 'customV21' ? customV21Issues : (issues || '0');

  return {
    dogName,
    breedNameValue,
    breedValue: getLocalizedBreedName(breedNameValue, lang),
    puppyValue,
    issues,
    customV21Issues,
    issuesDisplay,
  };
}
